(ns quuppa.qsm.api-keys.subs
  (:require [re-frame.core :as rf]))

;; TODO: Check the need for this. 
;; It currently returns nil, because the connecting event :qsm/api-keys is not being triggered by anything.
(rf/reg-sub
  :qsm/api-keys
  (fn [db [_ qpe-identity]]
    (get-in db [:qpes qpe-identity :api-keys])))
